const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.dynamicRoute.routes, // 改为使用动态路由
  errorLogs: state => state.errorLog.logs,
  routerData: state => state.user.routerData,
  user: state => state.user,
  permissions: state => state.user.permissions,
  permissionsAll: state => state.permissionsAll,
  // 动态路由相关getters
  dynamicRoutes: state => state.dynamicRoute.routes,
  routesLoaded: state => state.dynamicRoute.routesLoaded,
  currentSystem: state => state.dynamicRoute.currentSystem
}
export default getters
